import { CompetitionTypeNameEnum } from '~/apis/ssf';

/**
 * @deprecated this now exists as a property in the API as `description`, consider using that instead.
 */
export function competitionTypeNameToLabel(name: CompetitionTypeNameEnum) {
  return {
    EBP: 'Utrustad Bänkpress',
    CPL: 'Klassiskt Styrkelyft',
    EPL: 'Utrustat Styrkelyft',
    CBP: 'Klassisk Bänkpress',
    PBP: 'Paralympisk Bänkpress',
    SPL: 'Special Olympics Styrkelyft',
  }[name];
}

export function isBenchpressCompetition(competitionType: CompetitionTypeNameEnum) {
  return ['EBP', 'CBP', 'PBP'].includes(competitionType);
}
